import ClickOnce from './click-once';

export default ClickOnce;
